import Typography from "@portal/components/atoms/v2/typography";
import { IRiskLevelProposal } from "@portal/types/robot/IRiskLevelProposal";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";

interface Props {
  proposal: IRiskLevelProposal | undefined;
  isDefaultLanguage: boolean;
}

/**
 * Component for a bar to display the level of risk
 * @returns a status bar.
 */
export const RiskLevelBarComponent = ({ proposal, isDefaultLanguage }: Props) => {
  const fillLevel = proposal?.shares ?? 0;
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;

  return (
    <div className="flex flex-col my-1">
      <div className="flex w-full border rounded-lg bg-grey h-max-[16px]">
        <div
          style={{ width: `${fillLevel}%` }}
          className={`flex bg-greenDark h-3 w-0 rounded-l-lg ${fillLevel === 100 ? "rounded-r-lg" : ""} transition-all ease-out duration-1000`}
        />
      </div>
      <div className="flex flex-row justify-between">
        <div className="flex">
          <Typography variant="Body">{texts.PAGE_12_CAREFUL}</Typography>
        </div>
        <div className="flex">
          <Typography variant="Body">{texts.PAGE_12_BALANCED}</Typography>
        </div>
        <div className="flex">
          <Typography variant="Body">{texts.PAGE_12_OFFENSIVE}</Typography>
        </div>
      </div>
    </div>
  );
};
